import React from 'react';
import classes from './Button.module.css';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  disabled = false,
  type = 'button',
  className = '',
  fullWidth = false
}) => {
  const variantClass = variant === 'secondary' ? classes.secondary : classes.primary;
  const widthClass = fullWidth ? classes.fullWidth : '';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${classes.button} ${variantClass} ${widthClass} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
